type UnsubscribeAlertEmailContent = {
  title: string;
  heading: string;
  description: string;
};

export enum UnsubscribeAlertEmailStatus {
  UNSUBSCRIBED = 'UNSUBSCRIBED',
  ALREADY_UNSUBSCRIBED = 'ALREADY_UNSUBSCRIBED',
}

export type UnsubscribeAlertEmailProps = {
  unsubscribed: UnsubscribeAlertEmailContent;
  alreadyUnsubscribed: UnsubscribeAlertEmailContent;
  apiFailureMsg: string;
};
